import * as S from './style';
import { useNavigate } from 'react-router';
import SaveIcon from '../../community/Icon/SaveIcon';
import SearchIcon from '../../community/Icon/SearchIcon';
import CloseIcon from '../../community/Icon/CloseIcon';
import { useState } from 'react';
import SearchBar from 'src/refactor_components/common/SearchBar';

interface Props {
  setSearchData: React.Dispatch<React.SetStateAction<string>>;
  searchData: string;
}

const TmmunityHeader = ({ setSearchData, searchData }: Props) => {
  const [isSearching, setIsSearching] = useState(false);
  const navigate = useNavigate();
  return (
    <S.TabListSticky>
      {!isSearching ? (
        <>
          <S.TabList
            onClick={() => {
              navigate('/trainer-community');
            }}
          >
            트뮤니티
          </S.TabList>
          <div className="flex gap-16">
            <SaveIcon onClick={() => navigate('save')} />
            <SearchIcon onClick={() => setIsSearching(true)} />
          </div>
        </>
      ) : (
        <>
          <SearchBar searchData={searchData} setSearchData={setSearchData} />
          <CloseIcon
            onClick={() => {
              setIsSearching(false);
              setSearchData('');
            }}
          />
        </>
      )}
    </S.TabListSticky>
  );
};

export default TmmunityHeader;
